import { useEffect } from 'react';

import useScreenHeight from './useScreenHeight';
import useScreenWidth from './useScreenWidth';

const useObserver = (calcAndSetValue: () => void, element: HTMLDivElement | null, triggerParam?: any) => {
    const screenWidth = useScreenWidth();
    const screenHeight = useScreenHeight();

    useEffect(() => {
        if (element) {
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        calcAndSetValue();
                    }
                }
            });

            observer.observe(element, {
                attributes: true,
                childList: true,
                subtree: true,
            });

            const resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    if (entry.contentRect) {
                        calcAndSetValue();
                    }
                }
            });

            resizeObserver.observe(element);

            return () => {
                resizeObserver.unobserve(element);
                resizeObserver.disconnect();
                observer.disconnect();
            };
        }
    }, [element, screenWidth, screenHeight, triggerParam]);
};

export default useObserver;
